import { CR_SUBMISSION } from '../../../constants';

export type ScrollStarsIntoViewParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};

export const scrollStarsIntoView = ({ rootElement }: ScrollStarsIntoViewParams) => {
    const stars = rootElement.querySelector<HTMLInputElement>(CR_SUBMISSION.STAR_RATING.STARS_SELECTOR);
    if (stars === null) return;
    stars.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
};
